module.exports = __webpack_public_path__ + "img/export.db32ef57.svg";